import fs from "fs";
import AWS from "aws-sdk";
import util from "util";

function createS3() {
  return new AWS.S3({
    endpoint: new AWS.Endpoint(process.env.S3_PROTOCOL + process.env.S3_HOST),
    sslEnabled: false,
    credentials: new AWS.Credentials({
      accessKeyId: process.env.S3_KEY,
      secretAccessKey: process.env.S3_SECRET
    })
  });
}

export default function s3upload(municipality, service) {
  return async function (tmpPath, filename, mimetype, encoding, filePath) {
    const bucket = (process.env.S3_PREFIX || '') + (process.env.S3_BUCKET || municipality.alias.toLowerCase() + '-' + service.name.toLowerCase());
    console.log(`Uploading to bucket "${bucket}": ${filePath}, ${filename}, ${mimetype}, ${encoding}`);
    const s3 = createS3();
    const fileSize = (await util.promisify(fs.stat)(tmpPath)).size;
    return await new Promise((resolve, reject) =>
        s3.upload({
          Bucket: bucket,
          Key: filePath,
          Body: fs.createReadStream(tmpPath),
          ContentType: mimetype
        }, (err, data) => {
          if (err) {
            console.error('Upload failed!');
            console.error(err);
            return reject(err);
          }
          // data output
          //{ ETag: ${string},
          //   Location: 'https://${s3host}/${bucketname}/${filepath}',
          //   key: ${filepath},
          //   Key: ${filepath},
          //   Bucket: ${bucketname} }
          fs.unlinkSync(tmpPath);
          console.log('File uploaded');
          console.log({path: data.Key, filename, mimetype, encoding});
          return resolve({
            path: data.Key,
            filename,
            mimetype,
            encoding,
            size: fileSize
          });
        }));
  }
}